import { FC } from 'react'

import FinnishFlag from '../components/Icons/Flags/FinnishFlag'
import GermanFlag from '../components/Icons/Flags/GermanFlag'
import SwedishFlag from '../components/Icons/Flags/SwedishFlag'
import countryData from './countryData'
import BelgianFlag from '../components/Icons/Flags/BelgianFlag'
import AustrianFlag from '../components/Icons/Flags/AustrianFlag'
import DutchFlag from '../components/Icons/Flags/DutchFlag'
import ItalianFlag from '../components/Icons/Flags/ItalianFlag'

export interface ContactFormValues {
  phoneNumber: string
  workEmail: string
  estimatedAnnualVolume: string
  companyName: string
}

export interface DropdownCountryItem {
  label: string
  value: string
  flag?: FC
  phonePrefix?: string
}

export const COUNTRY_DROPDOWN_DATA: DropdownCountryItem[] = [
  {
    label: 'Finland',
    flag: FinnishFlag,
    value: 'fi',
    phonePrefix: '+358',
  },
  {
    label: 'Sweden',
    flag: SwedishFlag,
    value: 'sv',
    phonePrefix: '+46',
  },
  {
    label: 'Germany',
    flag: GermanFlag,
    value: 'de',
    phonePrefix: '+49',
  },
  {
    label: 'Austria',
    flag: AustrianFlag,
    value: 'at',
    phonePrefix: '+43',
  },
  {
    label: 'Belgium',
    flag: BelgianFlag,
    value: 'be',
    phonePrefix: '+32',
  },
  {
    label: 'Netherlands',
    flag: DutchFlag,
    value: 'nl',
    phonePrefix: '+31',
  },
  {
    label: 'Italy',
    flag: ItalianFlag,
    value: 'it',
    phonePrefix: '+39',
  },
  ...countryData,
]
